import type { ActionContext } from 'vuex'

import type { ActionClass, IndexJobDTO, IndexState } from '../../../models'
import type {
  IndexJobService,
  IndexJobServiceUpdateConfigParams,
} from '../../../services/interfaces'

import { CONTAINER } from '../../../config/inversify.config'

import { TYPES } from '../../../config/inversify.types'

export class UpdateConfigAction implements ActionClass {
  static execute(
    this: void,
    context: ActionContext<IndexState, unknown>,
    params: IndexJobServiceUpdateConfigParams,
  ): Promise<IndexJobDTO> {
    const service = CONTAINER.get<IndexJobService>(TYPES.IndexJobService)
    return service.updateConfig(params)
  }
}
